import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.black,
  paraColor: colors.black,
  subHeadingColor: colors.deepOrange,
  bgColor: colors.white,
  ctaColor: colors.deepOrange,
  textColorDark: colors.black,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;